var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIconFilled = function SvgHomeIconFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.606.933a.83.83 0 0 1 .906.076l7.5 5.834c.202.158.32.4.321.657v9.167a2.5 2.5 0 0 1-2.5 2.5h-5v-7.5a.833.833 0 0 0-1.666 0v7.5h-5a2.503 2.503 0 0 1-2.5-2.5V7.5c0-.257.119-.5.321-.657l7.5-5.834z"
  })));
};
export default SvgHomeIconFilled;